import { NgModule } from '@angular/core';
import { ComponentsModule } from 'components/components.module';
import { NutritionOptionsPage } from './nutrition-options-page';
import { PagesModule } from 'pages/pages.module';

@NgModule({
    declarations: [NutritionOptionsPage],
    imports: [PagesModule, ComponentsModule],
    exports: [NutritionOptionsPage]
})
export class NutritionOptionsPageModule { }
